import type { UserAttributeDtoKind } from '../UserAttributes/UserAttributesMapping';

export enum MATCH_OPERATION {
  SIMPLE = 'simple',
  EXACT = 'exact',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  CONTAINS = 'contains',
  REGEX = 'regex',
  GREATER_THAN = 'greater_than',
  LESS_THAN = 'less_than',
  MORE_THAN_DAYS_AGO = 'more_than_days_ago',
  LESS_THAN_DAYS_AGO = 'less_than_days_ago',
  EXACTLY_DAYS_AGO = 'exact_days_ago',
  EXACT_DATE = 'exact_date',
  UNKNOWN = 'unknown',
}

export enum RULE_TRIGGER_TYPE {
  URL = 'url',
  TRIGGER = 'trigger',
  DEVICE = 'device',
  ATTRIBUTE = 'attribute',
}

export interface TargetingRule {
  component: RULE_TRIGGER_TYPE;
  // eslint-disable-next-line camelcase
  match_operation?: MATCH_OPERATION;
  negate: boolean;
  pattern?: string | boolean | number;
  uiUuid: string;
  error?: string;
  // eslint-disable-next-line camelcase
  rule_type?: UserAttributeDtoKind;
  name?: string;
}

export const PAGE_TARGETING_RULE_TYPES: RULE_TRIGGER_TYPE[] = [
  RULE_TRIGGER_TYPE.URL,
  RULE_TRIGGER_TYPE.TRIGGER,
];
